// extracted by mini-css-extract-plugin
export default {"content":"aK","wrapper":"bK","gif":"cK","textContent":"eK","gifContainer":"fK","proteinGif":"gK","counter_img":"hK","usage-container":"iK","usage-list":"jK","checklist":"kK","counter_title":"lK","counter_wrapper":"mK","active":"nK","usage-counter":"oK","line":"pK"};
    if(module.hot) {
      // 1713969934676
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  